"use client";
import AnimateBoxSlideDown from "@/components/animation/AnimateBoxSlideDown";
import ContainerLayout from "@/layouts/ContainerLayout";
import { motion } from "framer-motion";
import React from "react";

const HeroSectionAwSportTeam = () => {
  return (
    <section>
      <ContainerLayout>
        <div className="flex flex-col items-center justify-center my-20 ">
          <AnimateBoxSlideDown margin="0px">
            <h1 className="text-5xl lg:text-7xl text-center mb-10 ">
              Zapisz się na treningi i dołącz do{" "}
              <span className="text-awSea">#&nbsp;AW-Sport Team</span>
            </h1>
          </AnimateBoxSlideDown>
          <AnimateBoxSlideDown delay={0.3} margin="0px">
            <h2 className="text-xl lg;text-2xl text-awGray text-center max-w-xl font-light">
              Odkryj moc indywidualnych treningów dołączając do naszej
              społeczności!
            </h2>
          </AnimateBoxSlideDown>
        </div>
      </ContainerLayout>
    </section>
  );
};

export default HeroSectionAwSportTeam;
